import { useToast } from '@foxtaibox/foxtailbox-frontend-core';
import useHandleLogin from '../Login/hooks/useHandleLogin';
import { OAuthRequestEndData } from './types';

// eslint-disable-next-line import/prefer-default-export
export const useParseOAuthRequestEndData = () => {
  const { showErrorToast } = useToast();
  const handleLogin = useHandleLogin();

  const parseOAuthRequestEndData = (data?: OAuthRequestEndData) => {
    if (data?.error) {
      showErrorToast(data.error);
    }
    if (data?.errorInstance) {
      // eslint-disable-next-line no-console
      console.log(data.errorInstance);
    }
    if (data?.payload) {
      handleLogin(data.payload.accessToken, data.payload.refreshToken);
    }
  };

  return parseOAuthRequestEndData;
};
